module.exports = __webpack_public_path__ + "akne_6_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_6_after.jpg
// module id = 925
// module chunks = 0